import { UploadSDKV2 } from '@isp/upload-sdk';
import { getIsPriv } from 'config';
import { getOrgCode, getStaffId, getUserToken } from 'data/storage';
import { generateUUIDWithoutHyphens } from 'api/request';

const UploadSDK = new UploadSDKV2({
  host: '', // 此处为空使用 bff 的 taroProxy 代理
  serviceMode: 'maxhub',
  serviceHeader: () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getUserToken()}`,
    'X-Staff-Id': getStaffId(),
    'x-org-code': getOrgCode(),
    'x-isp-traceid': generateUUIDWithoutHyphens()
  }),
  isPriv: getIsPriv()
});

export default UploadSDK;
